/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPAssessmentReportUIDTOV0 } from './rdSAPAssessmentReportUIDTOV0';
import { RdSAPSuggestedImprovementUIDTOV0 } from './rdSAPSuggestedImprovementUIDTOV0';


/**
 * An object containing the full details of the RdSAP assessment that can be serialized into JSON. Contains all relevant RdSAP assessment data for a particular property address and tenant, including current and potential energy ratings and demands.
 */
export interface RdSAPDataSetDtoV0 { 
    /**
     * Unique identifier for the property address being assessed.
     */
    readonly addressReference: string;
    /**
     * `RdSAP Assessment Report` Number. The Unique Id & primary index for storage. This value is globally unique.
     */
    readonly reportReferenceNumber?: string;
    /**
     * Indicates the type of data set, whether imported or calculated.
     */
    readonly dataSetType?: RdSAPDataSetDtoV0.DataSetTypeEnum;
    /**
     * The date and time when the assessment calculation was performed, if applicable.
     */
    readonly calculationDate?: string | null;
    /**
     * The current SAP (Standard Assessment Procedure) rating, assessing the energy efficiency of the property.
     */
    readonly sapRating?: number;
    /**
     * The potential SAP rating, indicating the possible energy efficiency if suggested improvements are implemented.
     */
    readonly potentialSAPRating: number;
    /**
     * The current Environmental Impact (EI) Rating, which measures the property\'s impact on the environment.
     */
    readonly eiRating?: number;
    /**
     * The potential Environmental Impact rating achievable after improvements.
     */
    readonly potentialEI: number;
    /**
     * The current co2 emissions rate for the property.
     */
    readonly co2EmissionCurrent: number;
    /**
     * The potential co2 emissions rate following suggested improvements.
     */
    readonly co2EmissionPotential: number;
    /**
     * The current demand for space heating in the property, measured in kWh per year.
     */
    readonly spaceHeatingDemand: number;
    /**
     * The current demand for water heating, indicating energy consumption for hot water.
     */
    readonly waterHeatingDemand: number;
    /**
     * The current primary energy use, which is the total energy required for heating, hot water, lighting, and other systems.
     */
    readonly primaryEnergyUseCurrent: number;
    /**
     * The estimated primary energy use after implementing suggested energy improvements.
     */
    readonly primaryEnergyUsePotential: number;
    /**
     * The total floor area of the property measured in square meters.
     */
    readonly totalFloorArea: number;
    /**
     * The RdSAP v20 XML string data for the `RdSAP Assessment Report`. 
     */
    readonly data?: string | null;
    /**
     * The timestamp when this data set was created.
     */
    readonly creationTime?: string;
    /**
     * Indicates whether the data set is currently active and relevant.
     */
    readonly isActive?: boolean;
    /**
     * The text User name of the individual who created or modified the data set.
     */
    readonly user?: string | null;
    jsonDetails?: RdSAPAssessmentReportUIDTOV0;
    /**
     * A collection of suggested improvements to enhance the property\'s energy performance.
     */
    readonly rdSapSuggestedImprovements?: Array<RdSAPSuggestedImprovementUIDTOV0>;
}
export namespace RdSAPDataSetDtoV0 {
    export type DataSetTypeEnum = 'Import' | 'Calculation';
    export const DataSetTypeEnum = {
        Import: 'Import' as DataSetTypeEnum,
        Calculation: 'Calculation' as DataSetTypeEnum
    };
}


